export const reduxKey = '@@PackagePicker';
